var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormatAudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E36A6",
  fillRule: "evenodd",
  d: "M2 19a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zM3 5v14h18V5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E36A6",
  d: "M7 10.29v3.42h2.222L12 16.561V7.439l-2.778 2.85zm3.889-.097v3.614L9.683 12.57H8.111v-1.14h1.572zM14.499 12c0-1.01-.566-1.876-1.388-2.298v4.59A2.56 2.56 0 0 0 14.5 12Zm-1.388-5v1.174c1.605.49 2.778 2.019 2.778 3.826s-1.172 3.335-2.778 3.826V17C15.339 16.481 17 14.44 17 12s-1.661-4.481-3.889-5"
})));
export default SvgFormatAudio;